module.exports = __webpack_public_path__ + "static/media/notes.2d67b9d6.jpg";